/**
 * In the /scripts/singletons/DomManager file, when using the setComponents
 * method, all components placed in export default are looped and initialized
 * automatically.
 */
import FilterCollapse from "@js/components/FilterCollapse";
import ResultsTemplate from "@js/components/ResultsTemplate";
import Select from "@js/components/Select";
import Slider from "@js/components/Slider";
import Tabs from "@js/components/Tabs";

/**
 * If you want to pass separate parameters or want to initialize a component
 * manually, you have to:
 * - Export it by itself =>
 *   export { default as Button } from "@/scripts/components/Button";
 * - Import it in the main.js file =>
 *   import { Button } from "@/scripts/components";
 * - Use the DomManager to register it:
 *   DomManager.registerComponent(".js-button", Button);
 */
// export { default as Button } from "@/scripts/components/Button";

export default {
	Slider,
	Select,
	FilterCollapse,
	ResultsTemplate,
	Tabs,
};
